"use client";
import { useState } from "react";
import { RxCross2 } from "react-icons/rx";

const FilterPanel = ({
  column,
  data,
  activeFilters,
  onApply,
  onClear,
  onClose,
}) => {
  const [selectedValues, setSelectedValues] = useState(activeFilters || []);
  const [searchTerm, setSearchTerm] = useState("");

  // Get unique values for the column
  const uniqueValues = [...new Set(data.map((item) => item[column.key]))]
    .filter(Boolean)
    .sort();

  // Filter values based on search term
  const filteredValues = uniqueValues.filter((value) =>
    String(value).toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Handle checkbox change
  const handleCheckboxChange = (value) => {
    setSelectedValues((prev) => {
      if (prev.includes(value)) {
        return prev.filter((v) => v !== value);
      } else {
        return [...prev, value];
      }
    });
  };

  // Handle select all
  const handleSelectAll = () => {
    if (selectedValues.length === filteredValues.length) {
      setSelectedValues([]);
    } else {
      setSelectedValues([...filteredValues]);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 z-50 flex justify-center items-center">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-md mx-4">
        <div className="flex justify-between items-center p-4 border-b">
          <h3 className="text-lg font-medium">Filter: {column.label}</h3>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            <RxCross2 className="text-lg" />
          </button>
        </div>

        <div className="p-4">
          <div className="mb-4">
            <input
              type="text"
              placeholder="Search values..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
            />
          </div>

          <div className="mb-2 flex items-center">
            <input
              type="checkbox"
              id="select-all"
              checked={
                selectedValues.length === filteredValues.length &&
                filteredValues.length > 0
              }
              onChange={handleSelectAll}
              className="h-4 w-4 text-primary border-gray-300 rounded"
            />
            <label
              htmlFor="select-all"
              className="ml-2 text-sm font-medium text-gray-700"
            >
              Select All
            </label>
          </div>

          <div className="max-h-60 overflow-y-auto">
            {filteredValues.length === 0 ? (
              <div className="text-center py-4 text-gray-500">
                No values found
              </div>
            ) : (
              filteredValues.map((value, index) => (
                <div key={index} className="flex items-center mb-2">
                  <input
                    type="checkbox"
                    id={`value-${index}`}
                    checked={selectedValues.includes(value)}
                    onChange={() => handleCheckboxChange(value)}
                    className="h-4 w-4 text-primary border-gray-300 rounded"
                  />
                  <label
                    htmlFor={`value-${index}`}
                    className="ml-2 text-sm text-gray-700 truncate"
                  >
                    {value}
                  </label>
                </div>
              ))
            )}
          </div>
        </div>

        <div className="flex justify-end p-4 border-t">
          <button
            onClick={onClear}
            className="px-3 py-1.5 bg-gray-200 text-gray-700 rounded-md text-sm hover:bg-gray-300 mr-2"
          >
            Clear
          </button>
          <button
            onClick={() => onApply(selectedValues)}
            className="px-3 py-1.5 bg-primary text-white rounded-md text-sm hover:bg-primary/90"
          >
            Apply
          </button>
        </div>
      </div>
    </div>
  );
};

export default FilterPanel;
